import store from "@/store";
import Vue from 'vue';
import Trimaster from "@/plugins/servers/trimaster";
const state = {
  sensorReadings: {},
  updatedReading: null
}

const getters = {
  sensorReadings: (state) => state.sensorReadings,
  sensorReading: (state) => (deviceId) => {
    return state.sensorReadings[deviceId] ? state.sensorReadings[deviceId] : null
  },
  primaryPlatformGroupSensorReading: (state) => (platformGroupId, designatorId) => {
    const primaryDeviceId = Object.keys(state.sensorReadings).find(deviceId => {
      const device = state.sensorReadings[deviceId]
      return device.platformGroup_id === platformGroupId
        && device.priority > 0
        && device.designator_id === designatorId
    })
    return primaryDeviceId ? state.sensorReadings[primaryDeviceId] : null
  },
  primarySensorReadingForController: (state) => (controllerId, designatorId) => {
    const primaryDeviceId = Object.keys(state.sensorReadings).find(deviceId => {
      const device = state.sensorReadings[deviceId]
      return device.controller_id === controllerId
        && device.priority > 0
        && device.designator_id === designatorId
    })
    return primaryDeviceId ? state.sensorReadings[primaryDeviceId] : null
  },
  platformGroupCollectionSensors: (state) => (platformGroupCollectionId, designatorId = null) => {
    const sensors = []
    Object.keys(state.sensorReadings).forEach(deviceId => {
      const device = state.sensorReadings[deviceId]
      if (device.platformGroupCollection_ids
        && device.platformGroupCollection_ids.includes(platformGroupCollectionId)
        && (!designatorId || device.designator_id === designatorId)
      ) {
        sensors.push(device)
      }
    })
    return sensors
  },
  updatedReading: (state) => state.updatedReading,
}

const actions = {
  async loadSensorReadings({commit}) {
    let [res, err] = await Trimaster.get('latest-sensor-readings/loadFacilitySensors', store.getters['getUser'].apitoken)
    if (res && res.success) {
      commit('setSensorReadings', res.data)
    }
  },
  async loadSensorReading({commit}, deviceId) {
    let [res, err] = await Trimaster.get('latest-sensor-readings/loadFacilitySensor', store.getters['getUser'].apitoken, {
      deviceId: deviceId
    })
    if (!err && res.success) {
      commit('addReading', res.reading)
    }
  },
  async updateReading({state, commit}, reading) {
    const deviceId = reading.payload.deviceId
    if (state.sensorReadings[deviceId]) {
      switch (reading.type) {
        case 'reportSensorReading':
          commit('updateSensorReading', {
            device_id: reading.payload.deviceId,
            reading: reading.payload.reading,
            dbtime: reading.payload.data.timestamp
          })
          break;
        case 'reportReading':
          commit('updateSensorReading', {
            device_id: reading.payload.deviceId,
            reading: reading.payload.reading,
            dbtime: reading.payload.data.timestamp,
            platformGroup_id: reading.payload.platformGroupId,
            controller_id: reading.payload.controllerId,
          })
          break;
        case 'sensorNameChanged':
          commit('updateSensorReading', {
            device_id: reading.payload.deviceId,
            name: reading.payload.name,
          })
          break;
      }
    } else {
      let [res, err] = await Trimaster.get('latest-sensor-readings/loadFacilitySensor', store.getters['getUser'].apitoken, {
        deviceId: deviceId
      })
      if (!err && res.success) {
        commit('addReading', res.reading)
      }
    }
  },
  async updateBattery({state, commit}, message) {
    const deviceIds = message.payload.deviceIds
    const devicePromises = []
    for (const deviceId of deviceIds) {
      if (state.sensorReadings[deviceId]) {
        commit('updateSensorReading', {
          device_id: deviceId,
          batteryLevel: message.payload.batteryLevel,
        })
      } else {
        devicePromises.push(Trimaster.get('latest-sensor-readings/loadFacilitySensor', store.getters['getUser'].apitoken, {
          deviceId: deviceId
        }))
      }
    }
    if (devicePromises.length) {
      let responses = await Promise.all(devicePromises)
      responses.forEach(([res, err]) => {
        if (!err && res.success) {
          commit('addReading', res.reading)
        }
      })
    }
  },
  async updateSensorPriority({state, commit}, message) {
    const deviceId = message.payload.deviceId
    if (state.sensorReadings[deviceId]) {
      commit('updateSensorReading', {
        device_id: message.payload.deviceId,
        priority: message.payload.priority,
      })
    } else {
      let [res, err] = await Trimaster.get('latest-sensor-readings/loadFacilitySensor', store.getters['getUser'].apitoken, {
        deviceId: deviceId
      })
      if (!err && res.success) {
        commit('addReading', res.reading)
      }
    }
  }
}

const mutations = {
  updateSensorReading(state, reading) {
    state.sensorReadings[reading.device_id] = {
      ...state.sensorReadings[reading.device_id],
      ...reading
    }
    Vue.set(state, 'updatedReading', state.sensorReadings[reading.device_id])
  },
  addReading(state, reading) {
    Vue.set(state.sensorReadings, reading.device_id, reading)
    Vue.set(state, 'updatedReading', reading)
  },
  setSensorReadings(state, readings) {
    const readingsById = {}
    readings.forEach(reading => {
      readingsById[reading.device_id] = reading
    })
    state.sensorReadings = readingsById
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
